import { ENodeTypes, TDocumentTree } from "../../types";
import '../../scss/document-tree.scss';
import { TreeNode } from "./TreeNode";
import { TreeLeaf } from "./TreeLeaf";

export const DocumentTree = ({ tree, fetcher }: { tree: TDocumentTree, fetcher?: (...props: any) => any }) => {

    return (
        <div className='lint-document-tree'>
            {
                tree.map((node, idx) =>
                    node.type === ENodeTypes.NODE
                        ? <TreeNode key={`${idx}-${node.title}-1`} {...node} fetcher={fetcher} />
                        : <TreeLeaf key={`${idx}-${node.data.title}-1`} {...node} />
                )
            }
        </div>
    )
}
